import {
  CAR_DATA_MASTER_GET_MODELS_BEGIN,
  CAR_DATA_MASTER_GET_MODELS_SUCCESS,
  CAR_DATA_MASTER_GET_MODELS_FAILURE,
  CAR_DATA_MASTER_GET_MODELS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM } from '../../../common/config';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getModels(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_MODELS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM + "/abms/model" + args);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            const models = res.data.data;
            if (models.length > 0) {
              models.forEach((model) => {
                model['brand_name'] = model?.Brand?.name;
                model['category_id'] = model?.category_id ?? model?.Category?.id;
                model['category_name'] = model?.Category?.name;
                model['canDelete'] = false;
                model['files'] = {};
              });
              dispatch({
                type: CAR_DATA_MASTER_GET_MODELS_SUCCESS,
                data: models,
                pagination: res.data.pagination
              });
              resolve(res);
            } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_MODELS_SUCCESS,
                data: [],
                pagination: res.data.pagination
              });
              resolve(res);
            }
          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_MODELS_FAILURE,
              data: [],
            });
            reject();
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CAR_DATA_MASTER_GET_MODELS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetModelsError() {
  return {
    type: CAR_DATA_MASTER_GET_MODELS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_MODELS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getModelsPending: true,
        getModelsError: null,
      };

    case CAR_DATA_MASTER_GET_MODELS_SUCCESS:
      // The request is success
      return {
        ...state,
        getModelsPending: false,
        getModelsError: null,
        modelListOrigin: [...action.data],
        modelList: [...action.data],
        modelsPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_MODELS_FAILURE:
      // The request is failed
      return {
        ...state,
        getModelsPending: false,
        getModelsError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_MODELS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getModelsError: null,
      };

    default:
      return state;
  }
}
